export class LoggedUser {
    constructor(
        public userName?: String,
        public userId?: String,
        public authtoken?:String,
        public firstName?:String,
        public lastName?:String){}
}
